import React, { Component } from 'react';


class Header extends Component {

  Logout=()=>{
    sessionStorage.clear();
    window.location.replace("/admin-login")
  }
  render() {

    return (<>

      <header id="header">
          <nav className="navbar-fixed-top navbar" role="navigation">
            <div className="container-fluid">
                <div className="navbar-header">
                    <button type="button" data-target="#aside" id="toggle_btn">
                      <i className="fa fa-align-left"></i>
                    </button>
                    <a className="navbar-brand" href="javascript:void(0)">
                       <img src="assests/images/logo.png" alt="img"/>
                    </a>
                    <button type="button" data-target="#search" data-toggle="collapse" className="navbar-toggle">
                      <i className="fa fa-search"></i>
                    </button>
                </div>
              <div className="col-sm-9 top_bar">
                <ul className="nav navbar-nav top_menu d-flex justify-content-end">
                  <li>
                    <a href="javascript:void(0)" onClick={(e)=>this.Logout(e)}className="user_img">
                      <img src="assests/images/contact_pic.png" alt="img" />
                      <span className="user_name">&nbsp;Logout</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
      </header>
    </>
    );
  }
}

export default Header;
